import { QueryDtoOf } from '@40seas/entities/common';
import { Charge } from './charge.entity';
import { Buyer } from '@40seas/entities/buyers';

export class QueryChargeDto extends QueryDtoOf(Charge, [Buyer]) {}
